import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { LightTable } from "components/light-table";
import { withVar } from "themes/helpers";

export const ColumnWidths = {
  Avatar: "50px",
  Role: "7%",
  AutoAssignment: "20%",
  InvitationStatus: "33%",
  LiveChatRole: "15%",
  Actions: "25%",
};

export const AgentLightTableHead = styled.table`
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  table-layout: fixed;
  width: 100%;

  thead tr {
    border-bottom: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
    height: 35px;
    font-size: 12px;
    font-weight: 400;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
    position: relative;
    vertical-align: middle;
    text-align: left;
    padding: 0 10px;
    text-transform: uppercase;
  }

  thead tr th:first-child {
    width: 60px;
    text-align: center;
  }

  thead tr th:nth-child(3),
  thead tr th:nth-child(4) {
    @media (max-width: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.mobileBreakpoint
      }) {
      display: none;
    }
  }

  thead tr th {
    height: 35px;
    font-size: 12px;
    font-weight: 400;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
    padding: 0 10px;
    text-transform: uppercase;
    position: relative;
    vertical-align: middle;
    text-align: left;
  }
`;

export const AgentLightTableWrapper = styled.div`
  flex: 0 1 auto;
  min-height: 72px;
  overflow: auto;
`;

export const AgentLightTable = styled(LightTable)`
  tbody tr td {
    padding: 10px;
  }

  tbody tr td:first-child {
    width: 60px;
    text-align: center;
    padding-block: 12px;
    padding-left: 10px;
    padding-right: 0;
    font-size: 14px;
  }

  tbody tr td:nth-child(n + 3) {
    @media (max-width: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.mobileBreakpoint
      }) {
      display: none;
    }
  }

  tbody {
    line-height: 1.4;
  }
`;
